import { FC } from "react"
import success from "@assets/images/success.gif";
import Translate from "@service/Translate";
import { FeedbackSharing } from "./index";
import { FeedbackItems } from "./FeedbackItems";
import { Route } from "./Route";

export const Feedback: FC = () => {
    const { tr } = Translate;

    return (
        <div className="flight-survey-feedback">
            <Route />
            <div className="feedback-section">
                <div className="feedback-success flex flex-center justify-center">
                    <img
                        src={success}
                        alt="success"
                        className="icon-success"
                    />
                    <div className="desc">{tr("feedback_submitted_msg")}</div>
                </div>
                <FeedbackSharing />
                <FeedbackItems />
            </div>
        </div>
    )
}